import { render, staticRenderFns } from "./Floricultura.vue?vue&type=template&id=05fbc6e6&scoped=true"
import script from "./Floricultura.vue?vue&type=script&lang=js"
export * from "./Floricultura.vue?vue&type=script&lang=js"
import style0 from "./Floricultura.vue?vue&type=style&index=0&id=05fbc6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fbc6e6",
  null
  
)

export default component.exports